export enum TicketElementInternalKey {
  GENERAL_INVOICE_OR_PAYMENT_INQUIRIES = 'GeneralInvoiceOrPaymentInquiries',
  INVOICE = 'Invoice',
}
